import { Example } from "./Example";
import styles from "./Example.module.css";
const DEFAULT_EXAMPLES: string[] = [
    "What is the specific material used to clean the transparent plastic surfaces, such as mirrors?",
    "¿Qué material limpia y desengrasa las superficies de montaje del motor?",
    "What two end frame/station combinations define Major Zone 134's right boundary?"
];
const GPT4V_EXAMPLES: string[] = [
    "What is the specific material used to clean the transparent plastic surfaces, such as mirrors?",
    "¿Qué material limpia y desengrasa las superficies de montaje del motor?",
    "What two end frame/station combinations define Major Zone 134's right boundary?"
];
interface Props {
    onExampleClicked: (value: string) => void;
    useGPT4V?: boolean;
}
export const ExampleList = ({ onExampleClicked, useGPT4V }: Props) => {
    return (
        <ul className={styles.examplesNavList}>
            {(useGPT4V ? GPT4V_EXAMPLES : DEFAULT_EXAMPLES).map((question, i) => (
                <li key={i}>
                    <Example text={question} value={question} onClick={onExampleClicked} />
                </li>
            ))}
        </ul>
    );
};